import React, { useMemo } from 'react';
import styled from '@emotion/styled';

const Root = styled.div({
    padding: 0,
    margin: 0,
    position: 'absolute',
    top: '0',
    left: '0',
    width: '100%',
    height: '100vh',
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
    overflowX: 'hidden',
});

type NavbarProps = {
    visible: boolean;
}

const Header = styled.div<NavbarProps>(props => ({
    width: '100%',
    height: 'fit-content',
    flexGrow: 0,
    maxHeight: props.visible ? 'fit-content' : 0,
    overflow: props.visible ? 'visible' : 'hidden',
}));

const Body = styled.div({
    display: 'flex',
    alignItems: 'top',
    overflow: 'hidden',
    flexGrow: 1,
});

type SidebarProps = {
    visible: boolean;
}

const ShrinkableSidebar = styled.div<SidebarProps>(props => ({
    flexShrink: 0,
    flexGrow: 0,
    width: 'fit-content',
    minHeight: '100%',
    overflowY: 'auto',
    maxWidth: props.visible ? '100%' : 0,
    transition: 'max-width 0.3s ease-out 0s',
    willChange: 'transition, max-width',
}));

const Main = styled.div({
    flexShrink: 1,
    flexGrow: 1,
    overflowY: 'auto',
    overflowX: 'hidden',
});

export type ThreePanesWithShrinkableSidebarProps = React.PropsWithChildren<{
    sidebarVisible: boolean;
    navbarVisible: boolean;
}>;

export const ThreePanesWithShrinkableSidebar = (props: ThreePanesWithShrinkableSidebarProps) => {
    const { children, sidebarVisible, navbarVisible } = props;

    const [header, sidebar, main] = Array.isArray(children) ? children : [];

    return (
        <Root>
            <Header visible={navbarVisible}>{useMemo(() => header || <div />, [header])}</Header>
            <Body>
                <ShrinkableSidebar visible={sidebarVisible} >{useMemo(() => sidebar || <div />, [sidebar])}</ShrinkableSidebar>
                <Main>{useMemo(() => main || <div />, [main])}</Main>
            </Body>
        </Root>
    );
};
